import { render } from "./DicomViewer.vue?vue&type=template&id=6d24c1c2&scoped=true"
import script from "./DicomViewer.vue?vue&type=script&lang=js"
export * from "./DicomViewer.vue?vue&type=script&lang=js"

import "./DicomViewer.vue?vue&type=style&index=0&id=6d24c1c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d24c1c2"]])

export default __exports__